import { API_BASE, type ApiClient } from "../api/client";
import { deviceToken } from "../app/device-token";
import { switchScreen } from "../app/switch-screen";

/**
 * "Kassa" in the Tafo app (Furkan, 18/10/2026): the owner opens the full till of app.tafo.be on this phone, in the
 * same app. The phone keeps a till token of its own next to the app's; the first time (or when that till was
 * unpaired in Beheer) the server pairs it on the owner's code, without a pairing code.
 */
export async function openOwnersTill(api: ApiClient): Promise<void> {
  const known = deviceToken.read();
  if (known === null || !(await stillPaired(known))) {
    const { deviceToken: token } = await api.request<{ deviceToken: string }>("POST", "/device/owner-till");
    deviceToken.save(token);
  }
  switchScreen("/");
}

async function stillPaired(token: string): Promise<boolean> {
  try {
    const response = await fetch(`${API_BASE}/device`, { headers: { "x-device-token": token } });
    return response.ok;
  } catch {
    // offline: the till shows that itself
    return true;
  }
}
